import { useMutation } from '@tanstack/react-query'

import { createPaymentLink } from '../paymentsService'

export function useCreatePaymentLink() {
  return useMutation({ mutationFn: createPaymentLink })
}
